import(/* webpackMode: "eager" */ "/opt/build/repo/app/terms/page.tsx")